import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CompaniesYouFollow } from "../../../components/admin/Dashboard/dashboard/CompaniesYouFollow";
import { WelcomeBanner } from "../../../components/admin/Dashboard/dashboard/WelcomeBanner";
import { Insights } from "../../../components/admin/Dashboard/dashboard/Insights";
import { PurchasedCompany } from "../../../components/admin/Dashboard/dashboard/PurchasedCompany";
import { VerificationBanner } from "../../../components/admin/Dashboard/dashboard/VerificationBanner";
import BusinessProfileWidget from "../../../components/public/Search/BusinesProfileWidget";
import { useGetUserSubscriptionListQuery } from "../../../store/Company/companyApiSlice";

function Dashboard() {
  const { userInfo, token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // TIP-464 — Sumsub KYC isn't wired in production right now. The dashboard
  // banner now only nudges users who haven't paid for the Verified Company
  // subscription. Hide when the user already has an active verified sub;
  // show otherwise. Click → /dashboard/billing where they can see plan state.
  const { data: subscriptionData } = useGetUserSubscriptionListQuery({
    individualID: userInfo?.individual?.[0]?.individualID,
    token,
  });
  const hasVerifiedSub = subscriptionData?.some(
    (s) => s?.subscription_type === "verified" && s?.status === "active",
  );

  const goToBilling = () => navigate("/dashboard/billing");

  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          {!hasVerifiedSub && <VerificationBanner onClick={goToBilling} />}
          <WelcomeBanner />
          <CompaniesYouFollow />
          <PurchasedCompany />
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col">
          <BusinessProfileWidget />
          <Insights />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
